import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { isAuthenticated } from '../../../../services/auth';
import { viewUser2, viewUser, followUser, unfollowUser } from '../../../../services/user';
import UnifiedDashboard from '../../../../components/layout/unified-dashboard';
import OptimizedList from '../../../../components/ui/lists/optimized-list';
import { Empty, Button, Avatar, Tabs, message } from 'antd';

const FollowList = () => {
  const countPerPage = 10;
  const [values, setValues] = useState({
    followers: [],
    following: [],
    favourites: [],
  });
  const [current, setCurrent] = useState(1);
  const [pagination, setPagination] = useState([]);
  const [tab, setTab] = useState('following');
  const [follow, setFollow] = useState(null);
  const [following2, setFollowing2] = useState([]);
  const [positiveRatings, setpositiveRatings] = useState([]);
  const [negativeRatings, setnegativeRatings] = useState([]);
  const positiveRating = [];
  const negativeRating = [];

  const { followers, following, favourites } = values;
  const { user, token } = isAuthenticated();

  useEffect(() => {
    loadUser(1);
    loadUser2();
  }, [follow]);

  const loadUser = async (page) => {
    let res = await viewUser2(user._id);
    setCurrent(page);
    //get user ratings
    res.data.ratings.forEach((item) => {
      if (item.rating === 'positive') {
        positiveRating.push(item._id);
        setpositiveRatings(positiveRating);
      } else if (item.rating === 'negative') {
        negativeRating.push(item._id);
        setnegativeRatings(negativeRating);
      }
    });
    setValues({
      followers: res.data.followers,
      following: res.data.following,
      favourites: res.data.favourites,
    });
    setPagination(
      (tab === 'following' ? res.data.following : res.data.followers).slice(
        (page - 1) * countPerPage,
        page * countPerPage
      )
    );
  };

  const loadUser2 = async () => {
    let res = await viewUser(user._id);
    setFollowing2(res.data.following);
  };

  useEffect(() => {
    loadUser(current);
  }, [tab]);

  const handleFollow = async (userId) => {
    try {
      await followUser(userId, user, token);
      setFollow((f) => !f);
    } catch (err) {
      if (err.response?.status === 400) {
        const errorMessage = err.response.data?.error || err.response.data?.message || err.response.data || 'Erro ao seguir usuário';
        message.error(typeof errorMessage === 'string' ? errorMessage : 'Erro ao seguir usuário');
      }
    }
  };

  const handleUnfollow = async (userId) => {
    try {
      await unfollowUser(userId, user, token);
      setFollow((f) => !f);
    } catch (err) {
      if (err.response?.status === 400) {
        const errorMessage = err.response.data?.error || err.response.data?.message || err.response.data || 'Erro ao deixar de seguir usuário';
        message.error(typeof errorMessage === 'string' ? errorMessage : 'Erro ao deixar de seguir usuário');
      }
    }
  };

  const renderUserCard = (p) => (
    <div className="d-flex align-items-center justify-content-between w-100 px-2 py-3 follow-list-item">
      <div className="d-flex align-items-center">
        <Link to={`/user/${p._id}`} className="text-decoration-none text-dark">
          <Avatar size="large" src={p.photo}>{p.name[0]}</Avatar>
        </Link>
        <div className="ms-3">
          <Link to={`/user/${p._id}`} className="fw-bold text-dark text-dark-hover text-decoration-none">{p.name}</Link>
          <div className="small text-muted">
            <span className="me-3">Seguidores: {p.followers.length}</span>
            <span>Seguindo: {p.following.length}</span>
          </div>
        </div>
      </div>
      {tab === 'following' ? (
        <Button type="primary" danger shape="round" onClick={() => handleUnfollow(p._id)}>
          Deixar de seguir
        </Button>
      ) : (
        !following2.includes(p._id) && (
          <Button type="primary" shape="round" onClick={() => handleFollow(p._id)}>
            Seguir
          </Button>
        )
      )}
    </div>
  );

  const tabItems = [
    {
      key: 'following',
      label: `Seguindo (${following.length})`,
      children: null,
    },
    {
      key: 'followers',
      label: `Seguidores (${followers.length})`,
      children: null,
    },
  ];

  return (
    <UnifiedDashboard title="Minha Rede" data={{ user, followers: followers.length, following: following.length, favourites: favourites.length }}>
      <div className="dashboard-content">
        <Tabs
          activeKey={tab}
          onChange={(k) => { setTab(k); loadUser(1); }}
          items={tabItems}
          size="large"
          className='follow-list-pagination'
        />
        <OptimizedList
          data={tab === 'following' ? following.slice((current-1)*countPerPage, current*countPerPage) : followers.slice((current-1)*countPerPage, current*countPerPage)}
          loading={false}
          total={tab === 'following' ? following.length : followers.length}
          pageSize={countPerPage}
          current={current}
          onPageChange={loadUser}
          renderItem={renderUserCard}
          emptyText={`Nenhum usuário encontrado`}
        />
      </div>
    </UnifiedDashboard>
  );
};

export default FollowList;
